import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedRequest } from 'src/app/paged-request.model';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';
import {
  CreateIncidentsImportRequest,
  GetAudiosIncidentsImportRequest,
  GetIncidentsImportDetailRequest,
  GetPagedIncidentsImportDetailResponse,
  GetPagedIncidentsImportResponse,
} from './incidents-import.model';

@Injectable({
  providedIn: 'root',
})
export class IncidentsImportService {
  private readonly baseURL: string =
    environment.apiUrl + '/api/AudioImportControl';

  constructor(private readonly http: HttpClient) {}

  get(filter: PagedRequest): Observable<GetPagedIncidentsImportResponse> {
    const params = serializeQueryParams(filter);

    return this.http.get<GetPagedIncidentsImportResponse>(this.baseURL, {
      params,
    });
  }

  post(request: CreateIncidentsImportRequest): Observable<any> {
    return this.http.post<any>(this.baseURL, request);
  }

  getDetails(
    filter: GetIncidentsImportDetailRequest
  ): Observable<GetPagedIncidentsImportDetailResponse> {
    const params = serializeQueryParams(filter);

    return this.http.get<GetPagedIncidentsImportDetailResponse>(
      this.baseURL + '/Details',
      {
        params,
      }
    );
  }

  getAudios(request: GetAudiosIncidentsImportRequest): Observable<any> {
    const params = serializeQueryParams(request);

    return this.http.get<any>(this.baseURL + '/Count', {
      params,
    });
  }
}
